// extracted by mini-css-extract-plugin
export default {"EnrichmentProgramItem":"EnrichmentProgramItem-module-b49563eaeefef60780a8"};